import controller from 'core/controllerPlans'
import updateDOM from './updateDOM'
import once from 'utils/functional/once'
import 'bootstrap/js/src/modal'
import initDOM from './initDOM'
import config from './config'
import './styles.scss'
import sessionHandler from 'core/controllers/sessionHandler'

const saveSession = sessionHandler({
  useState: true,
  save: true
})

const registry = [once(initDOM), updateDOM, once(saveSession)]

controller(config, registry)
